import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const HotelWifiLayout = lazy(() => import('./hotel-wifi-layout.tsx'));
const HotelWifiOverviewPage = lazy(() =>
  import('./pages/hotel-wifi-overview-page.tsx')
);
const HotelWifiBandwidthTiersPage = lazy(() =>
  import('./pages/hotel-wifi-bandwidth-tiers-page.tsx')
);
const HotelWifiGuestsPage = lazy(() => import('./pages/hotel-wifi-guests-page.tsx'));
const HotelWifiSessionsPage = lazy(() =>
  import('./pages/hotel-wifi-sessions-page.tsx')
);
const HotelWifiTierHistoryPage = lazy(() =>
  import('./pages/hotel-wifi-tier-history-page.tsx')
);
export const hotelWifiRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <HotelWifiLayout />
      </Suspense>
    ),
    children: [
      { index: true, element: <Navigate to="sessions" replace /> },
      {
        path: 'overview',
        element: (
          <Suspense>
            <HotelWifiOverviewPage />
          </Suspense>
        )
      },
      {
        path: 'bandwidth-tiers',
        element: (
          <Suspense>
            <HotelWifiBandwidthTiersPage />
          </Suspense>
        )
      },
      {
        path: 'guests',
        element: (
          <Suspense>
            <HotelWifiGuestsPage />
          </Suspense>
        )
      },
      {
        path: 'sessions',
        element: (
          <Suspense>
            <HotelWifiSessionsPage />
          </Suspense>
        )
      },
      {
        path: 'tier-history',
        element: (
          <Suspense>
            <HotelWifiTierHistoryPage />
          </Suspense>
        )
      }
    ]
  }
];
